import { PARTY_COLORS, type PartyConfig, type StaffingCellData, type StaffingRoleData } from 'admin/src/screens/admin/Pollworker/StaffingChart/staffingTypes';
import { generateHslColor } from 'shared/src/utils/colors';

export function isCellConfigured(cell: StaffingCellData | undefined): boolean {
  if (!cell) return false;
  if (cell.isNotApplicable) return true;

  const hasPartyData = cell?.partyBreakdown?.some((p) => p.count > 0) || false;

  return cell.total > 0 || hasPartyData;
}

export function isRoleComplete(role: StaffingRoleData, dates: string[]): boolean {
  return dates.every((date) => isCellConfigured(role.cells[date]));
}

export function getPartyColor(partyCode: string | undefined, parties: PartyConfig[]): string {
  if (!partyCode) return '#94a3b8';
  const party = parties.find((p) => p.partyCode === partyCode);
  if (party) return party.color;
  return PARTY_COLORS[partyCode] || generateHslColor(partyCode);
}

export function formatTime(time: string | undefined): string {
  if (!time) return '';

  const [hours, minutes, ampmFromTime] = time.split(/\:|\s/);
  const h = Number.parseInt(hours, 10);
  const ampm = ampmFromTime === 'PM' || h >= 12 ? 'p' : 'a';
  const hour12 = h % 12 || 12;

  return `${hour12}:${minutes}${ampm}`;
}
